module.exports = __webpack_public_path__ + "img/python.5b9068cf.png";